module.exports = __webpack_public_path__ + "img/Step3@2x.27afac13.jpg";